/*eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react';
import { Row, Col, Container } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { NetworkCard } from './NetworkCard';
import { PlanDetails } from './PlanDetails';
import CoveredServices from './CoveredServices';
import { BenefitsAvailed } from './BenefitsAvailed';
import { PlanDetailsForOthers } from './planDetailsForOthers';
import CustomClientError from '../../../../errorhandling/CustomClientError';
import Feature from '../../../../../services/feature';
import { insertSpaces } from '../../../../utils/strings';
import MasterPermissions from '../../../../api/MasterPermissions';
import { NetworkCardWithTier } from './NetworkCardWithTier';
import httpheader from 'src/Admin/shared/httpheader';

const CoverageDetails = ({
  dataFetching,
  isAPIFailed,
  isNotFound,
  CurrentActive,
  InNetworkPlanDetails,
  OutOfNetworkPlanDetails,
  PenaltyPlanDetails,
  activeCoverageType,
  activeMemType,
  activeOID,
  membersCovered,
  selectedUser,
  planDetails,
  coverageData,
  isFamilySelected,
  displayResetCoverageType,
  coverageTypes,
  benefitYearProps,
  networkProps,
  CloseResetCoverageTypeMessage,
  networkPlandetails,
  startEndDate,
  accumsFinalUrl,
  ...PlanInfo
}) => {
  const Coverage = coverageData[0]?.MemberCoverage;
  const CVRGTYPES = [];
  const cName = httpheader.getCNAME();
  Coverage &&
    Coverage.map((data) => {
      if (
        data?.Product === 'Medical' ||
        data?.Product === 'Dental' ||
        data?.Product === 'Prescription' ||
        data?.Product === 'Vision'
      ) {
        return;
      } else {
        CVRGTYPES.push(insertSpaces(data.Product));
        return;
      }
    });
  const { Ded_Plans, Oop_Plans } =
    useSelector((state) => state.app?.appConfigs) || {};
  const {
    Display_Penalty_OR_OutOfNetwork,
    Display_Tier_Network_Detailed_View,
  } =
    useSelector((state) => state.app.appConfigs.Network_Setting) ||
    'Out-Of-Network';
  const [selectedTier, setSelectedTier] = useState('');
  const [showDedLabel, setShowDedLabel] = useState(false);
  const [showOopLabel, setShowOopLabel] = useState(false);
  const [hideSecondCard, setHideSecondCard] = useState(false);
  const [displayTierFromOutOfNetwork, setDisplayTierFromOutOfNetwork] =
    useState(false);
  const { TierConfig } = useSelector((state) => state.app.appConfigs) || [];
  const { TlcConfig } = useSelector((state) => state.app.appConfigs) || [];
  useEffect(() => {
    if (
      (cName.includes('keenan') || cName.includes('tpabenefits')) &&
      PlanInfo?.BenefitPlan !== undefined
    ) {
      if (Ded_Plans !== undefined && Ded_Plans?.length > 0) {
        if (Ded_Plans.includes(PlanInfo?.BenefitPlan)) {
          setShowDedLabel(true);
        }
      }
      if (Oop_Plans !== undefined && Oop_Plans?.length > 0) {
        if (Oop_Plans.includes(PlanInfo?.BenefitPlan)) {
          setShowOopLabel(true);
        }
      }
      if (TierConfig?.length > 0) {
        const matchedPlans = TierConfig.filter(
          (planInformation) =>
            planInformation.BenefitPlanName.toLowerCase() ===
            PlanInfo?.BenefitPlan.toLowerCase(),
        );
        if (matchedPlans?.length > 0) {
          setDisplayTierFromOutOfNetwork(true);
        }
      }
      if (TlcConfig?.length > 0) {
        const matchedPlans = TlcConfig.filter(
          (planInformation) =>
            planInformation.BenefitPlanName.toLowerCase() ===
            PlanInfo?.BenefitPlan.toLowerCase(),
        );
        if (matchedPlans?.length > 0) {
          setHideSecondCard(true);
        }
      }
    }
  }, [PlanInfo]);
  return (
    <>
      <div className="coverage-details">
        {isAPIFailed ? (
          <div className="px-0">
            {isNotFound ? (
              <CustomClientError
                ErrorHeading="No Coverages found"
                ErrorMessage="The selected Member does not have any Coverages."
                CustomClasses="p-0"
              />
            ) : (
              <CustomClientError
                ErrorHeading="Something went wrong with request!"
                ErrorMessage="Please try again."
                CustomClasses="p-0"
              />
            )}
          </div>
        ) : (
          CVRGTYPES.indexOf(activeCoverageType) < 0 && (
            <>
              {displayResetCoverageType && (
                <Row>
                  <Col>
                    <div className="header-banner-msg position-relative mt-3 mb-0 mt-md-0 mb-md-4">
                      <div className="d-flex flex-row align-items-center">
                        <i
                          className="fa fa-exclamation-triangle"
                          aria-hidden="true"
                        ></i>
                        <div role="alert">
                          <span>
                            {`The specified filter does not have any Coverage. Default selection ${activeCoverageType} Coverage for ${
                              selectedUser?.label
                            } in ${
                              benefitYearProps?.selectedBenefitYear?.value
                            } (${
                              networkProps.selectedNetwork.label === 'ALL'
                                ? 'Default'
                                : networkProps.selectedNetwork.label
                            }) is displayed.`}
                          </span>
                        </div>
                      </div>
                      <button
                        onClick={CloseResetCoverageTypeMessage}
                        type="button"
                        className="close"
                        aria-label="Close"
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                    {!dataFetching && (
                      <CoveredServices
                        {...PlanInfo}
                        activeCoverageType={activeCoverageType}
                        activeMemType={activeMemType}
                        activeOID={activeOID}
                        benefitYear={
                          benefitYearProps?.selectedBenefitYear?.value
                        }
                        networkProps={networkProps.selectedNetwork}
                        CurrentActive={CurrentActive}
                        isFamilySelected={isFamilySelected}
                        dataFetching={dataFetching}
                        selectedUser={selectedUser}
                        networkPlandetails={networkPlandetails}
                      />
                    )}
                  </Col>
                </Row>
              )}
              <Row className="">
                <Col
                  md={4}
                  xs={12}
                  className="mb-3 mb-md-0 padding-mobile-0 mt-4 mt-sm-0"
                >
                  <PlanDetails
                    {...PlanInfo}
                    dataFetching={dataFetching}
                    activeMemType={activeMemType}
                    activeOID={activeOID}
                    activeCoverageType={activeCoverageType}
                    planDetails={planDetails}
                    coverageData={coverageData}
                    membersCovered={membersCovered}
                  />
                </Col>

                {MasterPermissions.CheckPermission(
                  'View Deductible and Out of Pocket',
                ) && (
                  <Col md={4} className="mb-3 mb-md-0">
                    {displayTierFromOutOfNetwork ? (
                      <NetworkCard
                        selectedUser={selectedUser}
                        isFamilySelected={isFamilySelected}
                        label="Out-of-network Summary"
                        PlanDetails={OutOfNetworkPlanDetails}
                        CurrentActive={CurrentActive}
                        dataFetching={dataFetching}
                        networkPlandetails={networkPlandetails}
                      />
                    ) : (
                      <NetworkCard
                        selectedUser={selectedUser}
                        isFamilySelected={isFamilySelected}
                        label="In-network Summary"
                        PlanDetails={InNetworkPlanDetails}
                        CurrentActive={CurrentActive}
                        dataFetching={dataFetching}
                        networkLabel={networkProps.selectedNetwork.label}
                        showDedLabel={showDedLabel}
                        showOopLabel={showOopLabel}
                      />
                    )}
                  </Col>
                )}
                {!hideSecondCard && (
                  <>
                    {Display_Tier_Network_Detailed_View === true ? (
                      <Col md={4} xs={12} className="">
                        <NetworkCardWithTier
                          label="Penalty Summary"
                          planDetails={planDetails}
                          PenaltyPlanDetails={PenaltyPlanDetails}
                          OutOfNetworkPlanDetails={OutOfNetworkPlanDetails}
                          CurrentActive={CurrentActive}
                          dataFetching={dataFetching}
                          networkPlandetails={networkPlandetails}
                          accumsFinalUrl={accumsFinalUrl}
                          networkProps={networkProps.options}
                          activeCoverageType={activeCoverageType}
                          setSelectedTier={setSelectedTier}
                          isFamilySelected={isFamilySelected}
                          showDedLabel={showDedLabel}
                          showOopLabel={showOopLabel}
                          displayTierFromOutOfNetwork={
                            displayTierFromOutOfNetwork
                          }
                        />
                      </Col>
                    ) : MasterPermissions.CheckPermission(
                        'View Deductible and Out of Pocket',
                      ) && Display_Penalty_OR_OutOfNetwork === 'Penalty' ? (
                      <Col md={4} className="mb-3 mb-md-0">
                        <NetworkCard
                          selectedUser={selectedUser}
                          isFamilySelected={isFamilySelected}
                          label="Penalty Summary"
                          PlanDetails={PenaltyPlanDetails}
                          CurrentActive={CurrentActive}
                          dataFetching={dataFetching}
                          networkPlandetails={networkPlandetails}
                        />
                      </Col>
                    ) : (
                      MasterPermissions.CheckPermission(
                        'View Deductible and Out of Pocket',
                      ) && (
                        <Col md={4} xs={12} className="">
                          <NetworkCard
                            selectedUser={selectedUser}
                            isFamilySelected={isFamilySelected}
                            label="Out-of-network Summary"
                            PlanDetails={OutOfNetworkPlanDetails}
                            CurrentActive={CurrentActive}
                            dataFetching={dataFetching}
                            networkPlandetails={networkPlandetails}
                          />
                        </Col>
                      )
                    )}
                  </>
                )}
              </Row>
              <Feature name="extendCoverage">
                <>
                  <Row className="covered-services mt-4">
                    <Col>
                      {!dataFetching && (
                        <CoveredServices
                          {...PlanInfo}
                          activeCoverageType={activeCoverageType}
                          activeMemType={activeMemType}
                          activeOID={activeOID}
                          benefitYear={
                            benefitYearProps.selectedBenefitYear.value
                          }
                          networkProps={networkProps.selectedNetwork}
                          CurrentActive={CurrentActive}
                          isFamilySelected={isFamilySelected}
                          dataFetching={dataFetching}
                          selectedUser={selectedUser}
                          networkPlandetails={networkPlandetails}
                          selectedTier={selectedTier}
                          displayTierFromOutOfNetwork={
                            displayTierFromOutOfNetwork
                          }
                          hideSecondCard={hideSecondCard}
                        />
                      )}
                    </Col>
                  </Row>
                  {/*{activeCoverageType === 'Short Term Disability' && <Row className="covered-services mt-4">
                  {!dataFetching&&<Col>
                    <BenefitsAvailed
                      activeOID={activeOID}
                      benefitYear={benefitYearProps.selectedBenefitYear.value}

                    />
                  </Col>}
                </Row>} */}
                </>
              </Feature>
            </>
          )
        )}
        {CVRGTYPES.indexOf(activeCoverageType) > -1 && (
          <div>
            {displayResetCoverageType && (
              <Row>
                <Col>
                  <div className="header-banner-msg position-relative mt-3 mb-0 mt-md-0 mb-md-4">
                    <div className="d-flex flex-row align-items-center">
                      <i
                        className="fa fa-exclamation-triangle"
                        aria-hidden="true"
                      ></i>
                      <div role="alert">
                        <span>
                          {`The specified filter does not have any Coverage. Default selection ${activeCoverageType} Coverage for ${
                            selectedUser?.label
                          } in ${
                            benefitYearProps?.selectedBenefitYear?.value
                          } (${
                            networkProps.selectedNetwork.label === 'ALL'
                              ? 'Default'
                              : networkProps.selectedNetwork.label
                          }) is displayed.`}
                        </span>
                      </div>
                    </div>
                    <button
                      onClick={CloseResetCoverageTypeMessage}
                      type="button"
                      className="close"
                      aria-label="Close"
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                </Col>
              </Row>
            )}
            <Row className="">
              <Col className="mb-3 mb-md-0 padding-mobile-0 mt-4 mt-sm-0">
                <PlanDetailsForOthers
                  activeCoverageType={activeCoverageType}
                  dataFetching={dataFetching}
                  planDetails={planDetails}
                  activeMemType={activeMemType}
                  activeOID={activeOID}
                  coverageData={coverageData}
                />
              </Col>
            </Row>
            {
              <Row className="covered-services mt-4">
                <Col>
                  {!dataFetching && (
                    <CoveredServices
                      {...PlanInfo}
                      activeCoverageType={activeCoverageType}
                      activeMemType={activeMemType}
                      activeOID={activeOID}
                      benefitYear={benefitYearProps?.selectedBenefitYear?.value}
                      networkProps={networkProps.selectedNetwork.value}
                      CurrentActive={CurrentActive}
                      selectedTier={selectedTier}
                    />
                  )}
                </Col>
              </Row>
            }
            {(activeCoverageType === 'Short Term Disability' ||
              activeCoverageType === 'Long Term Disability') && (
              <Row className="covered-services mt-4">
                {!dataFetching && (
                  <Col>
                    <BenefitsAvailed
                      activeOID={activeOID}
                      benefitYear={benefitYearProps?.selectedBenefitYear?.value}
                      yearORNetworkFilter={PlanInfo.yearORNetworkFilter}
                      startEndDate={startEndDate}
                    />
                  </Col>
                )}
              </Row>
            )}
          </div>
        )}
      </div>
    </>
  );
};

export default CoverageDetails;
